import React from "react";
import { createBrowserHistory } from "history";
import { Container } from "react-bootstrap";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import LandingPage from "./pages/Landing";
import DomesticPage from "./pages/Domestic";
import InternationalPage from "./pages/International";
import FireAssurancePage from "./pages/FireAssurance";
import PersonalPage from "./pages/Personal";
import TaAssurancePage from "./pages/TaAssurance";
import TaSawasdeePage from "./pages/TaSawasdee";
import "./App.scss";

const history = createBrowserHistory();

function App() {
  return (
    <Container className="content-body">
      <Router history={history}>
        <Switch>
          <Route exact path="/personal-assurance">
            <PersonalPage />
          </Route>
          <Route exact path="/fire-assurance">
            <FireAssurancePage />
          </Route>
          <Route exact path="/ta-happy-trip">
            <InternationalPage />
          </Route>
          <Route exact path="/ta-sawasdee">
            <TaSawasdeePage />
          </Route>
          <Route exact path="/domestic-assurance">
            <DomesticPage />
          </Route>
          <Route exact path="/ta-assurance">
            <TaAssurancePage />
          </Route>
          <Route exact path="/personal-assurance-landing">
            <PersonalPage />
          </Route>
          <Route exact path="/fire-assurance-landing">
            <FireAssurancePage />
          </Route>
          <Route exact path="/ta-sawasdee-landing">
            <TaSawasdeePage />
          </Route>
           <Route exact path="/ta-happy-trip-landing">
            <InternationalPage />
          </Route>
          <Route exact path="/domestic-assurance-landing">
            <DomesticPage />
          </Route>
          <Route exact path="/ta-assurance-landing">
            <TaAssurancePage />
          </Route>
          <Route exact path="/">
            <LandingPage />
          </Route>
        </Switch>
      </Router>
    </Container>
  );
}

export default App;
